<template>
  <form
    v-if="currentQuestion"
    class="testing-form"
  >
    <header class="form-head">
      <app-counter
        v-if="questions.length"
        :current="currentIndex + 1"
        :total="total"
      />
      <p
        class="form-head__title"
        v-html="currentQuestionText"
      />
    </header>
    <transition
      name="fade"
      mode="out-in"
    >
      <div
        v-if="currentQuestion.answers.length"
        :key="currentQuestion.id"
        class="form-body"
      >
        <app-input
          v-if="currentQuestion.isManual"
          v-model="manualValue"
          placeholder="Ответ"
          class="form__input"
          name="answer"
          type="text"
        />
        <app-radio-group
          v-else-if="test.type === TEST_TYPE.WITH_WEIGHT || hasOneAnswer"
          :key="`question-${currentQuestion.id}`"
          v-model="value"
          :levels="currentQuestion.answers"
          name="answer"
          @changeRadioButton="clickButton"
        />
        <app-checkbox-group
          v-else
          :key="`question-${currentQuestion.id}`"
          v-model="value"
          :levels="currentQuestion.answers"
        />
      </div>
    </transition>
    <footer class="form-footer">
      <app-button
        class="form-footer__button"
        icon="IconLeftRow"
        icon-position="left"
        type="button"
        @click.native="getPreviousQuestion"
      >
        Назад
      </app-button>
      <app-button
        v-if="showNext"
        class="form-footer__button"
        icon="IconRightRow"
        icon-position="right"
        type="button"
        @click.native="clickButton('next')"
      >
        Далее
      </app-button>
    </footer>
  </form>
</template>

<script>
import {
  mapActions,
  mapState,
  mapMutations,
} from 'vuex';

import AppCheckboxGroup from '@/components/Forms/AppCheckboxGroup.vue';
import AppButton from '../Base/AppButton';
import AppCounter from './AppCounter';
import AppRadioGroup from './AppRadioGroup';
import { TEST_TYPE } from '../../utils';
import AppInput from '../Base/AppInput';

export default {
  name: 'TestingForm',
  components: {
    AppInput,
    AppButton,
    AppCounter,
    AppRadioGroup,
    AppCheckboxGroup,
  },
  data() {
    return {
      TEST_TYPE,
      currentIndex: 0,
      total: 0,
      questions: [],
      lastUserAnswer: null,
    };
  },
  computed: {
    ...mapState('tests', ['userAnswers', 'userManualAnswers', 'test']),
    currentQuestion() {
      return this.questions[this.currentIndex];
    },
    currentQuestionText() {
      return this.currentQuestion.text.replace(/&nbsp;/g, ' ');
    },
    value: {
      get() {
        return this.userAnswers[`q${this.currentQuestion.id}`] || [];
      },
      set(val) {
        const oldVal = JSON.stringify(this.userAnswers[`q${this.currentQuestion.id}`]);
        const newVal = JSON.stringify(val);

        if (oldVal !== newVal) {
          this.setQuestionAnswers({
            isManual: false,
            key: `q${this.currentQuestion.id}`,
            list: val.map((id) => +id),
          });
        }
      },
    },
    manualValue: {
      get() {
        return this.userManualAnswers[`q${this.currentQuestion.id}`] || '';
      },
      set(val) {
        const oldVal = this.userManualAnswers[`q${this.currentQuestion.id}`];

        if (oldVal !== val) {
          this.setQuestionAnswers({
            isManual: true,
            key: `q${this.currentQuestion.id}`,
            list: val,
          });
        }
      },
    },
    hasOneAnswer() {
      if (this.test.type !== TEST_TYPE.SUBJECT) {
        return false;
      }
      return this.currentQuestion.answers.filter((answer) => answer.isRight).length === 1;
    },
    showNext() {
      return (this.test.type !== TEST_TYPE.WITH_WEIGHT && !this.hasOneAnswer) || !this.currentQuestion.answers || !this.currentQuestion.answers.length;
    },
  },
  watch: {
    currentIndex(val) {
      localStorage.setItem('lastCurrent', val);
    },
  },
  async created() {
    this.loadQuestions();
    this.initIndex();
  },
  methods: {
    ...mapMutations('tests', ['setQuestionAnswers']),
    ...mapActions('results', ['sendResult']),

    initIndex() {
      this.currentIndex = +localStorage.getItem('lastCurrent') || 0;
    },

    loadQuestions() {
      this.total = this.test.questions.length;
      this.questions = this.test.questions
        .sort((a, b) => a.id - b.id)
        .map(this.loadAnswers);
    },

    loadAnswers(question) {
      question.answers = this.test.answers
        .filter((el) => el.questionId === question.id);

      if (this.test.type === TEST_TYPE.WITH_WEIGHT) {
        question.answers.forEach(this.loadTemplate);
      }

      return question;
    },

    loadTemplate(answer) {
      answer.text = this.test.answerTemplates
        .find((at) => at.id === answer.templateId)?.text || '';
    },

    async clickButton(type) {
      const answers = this.currentQuestion.isManual ? this.userManualAnswers : this.userAnswers;
      if (type === 'next') {
        const currentAnswer = answers[`q${this.currentQuestion.id}`];
        if (!this.currentQuestion.answers || !this.currentQuestion.answers.length) {
          // nothing
        } else if (!currentAnswer || !currentAnswer.length) {
          // eslint-disable-next-line no-alert
          alert('Выберите ответ!');
          return;
        }
      }
      if (this.currentIndex + 1 !== this.total) {
        this.currentIndex += 1;
      } else {
        try {
          const { _id } = await this.sendResult();
          const { showResult } = this.test.base;
          const { id } = this.$route.params;
          const path = showResult ? `/results/${_id}` : `/${id}/finish`;
          this.$router.push(path);
        } catch (e) {
          // eslint-disable-next-line no-alert
          alert('Что то пошло не так');
          console.log(e);
        }
      }
    },
    // Обработчик нажатия кнопки назад
    async getPreviousQuestion() {
      let i = this.currentIndex;
      this.currentIndex = i > 0 ? i -= 1 : i;
    },
  },
};
</script>

<style lang="scss" scoped>
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
    opacity: 0;
  }
  .error {
    padding: 10px;
    color: rgb(212, 0, 0);
    font-weight: bold;
  }
  .testing-form {
    padding: 24px;
    width: 100%;
    background: #FFFFFF;
    border: 1px solid #DBDBDB;
    box-sizing: border-box;
    box-shadow: 0 4px 14px rgba(70, 97, 138, 0.2);
    border-radius: 8px;
  }
  .form-head {
    width: 100%;
    font-weight: 600;
    font-size: 22px;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    /deep/ strong {
      font-weight: 900;
    }
    ::v-deep img {
      max-width: 600px;
    }
    &__title {
      font-size: 17px;
      margin: 0 10px 0;
      /deep/ p {
        margin: 0;
        padding: 0;
      }
    }
  }
  .form-body {
    padding: 24px 0;
    margin: 24px 0;
    border-top: 1px rgb(200, 200, 200) solid;
    border-bottom: 1px rgb(200, 200, 200) solid;
    &__question {
      font-size: 16px;
      margin: 0;
    }
    &__list {
      list-style-type: none;
      padding: 0;
    }
  }
  .form-footer {
    display: flex;
    justify-content: space-between;
  }
  @media screen and (max-width: $window-md){
    .testing-form {
      width: 100%;
      .form-head {
        flex-direction: column;
      }
    }
  }
  @media screen and (max-width: $window-sm){
    .testing-form {
      width: 100%;
      .form-head {
        flex-direction: column;
      }
    }
    .form-head {
      &__title {
        font-size: 16px;
      }
    }
  }
  .form__input {
    ::v-deep input::placeholder {
      color: lightgray;
    }
  }
</style>
